import React, { useRef, useState } from 'react';
import { CaptionStyle, Caption } from '../../../types';

interface FontFamily {
  name: string;
  className: string;
}

interface FontAccordionProps {
  fontFamilies: FontFamily[];
  segment: Caption;
  handleStyleUpdate: (key: keyof CaptionStyle, value: any) => void;
}

const FontAccordion: React.FC<FontAccordionProps> = ({
  fontFamilies,
  segment,
  handleStyleUpdate,
}) => {
  const fontFamilySelected = useRef("");
  const [isOpen, updateIsOpen] = useState(false);
  //let isOpen = false;
  
  return (
    <details
      onClick={() => updateIsOpen((prev:boolean) => !prev)}
      style={{
        margin: '0px 0',
        backgroundColor: '#2d2d2d',
        color: '#e0e0e0',
        padding: '0',
        borderRadius: '4px',
        width: '100%',
        border: '1px solid #444',
        overflow: 'hidden'
      }}
    >
      <summary 
        style={{ 
          cursor: 'pointer', 
          fontWeight: 'bold', 
          fontSize: '16px',
          backgroundColor: '#333',
          padding: '8px 12px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          listStyle: 'none',
          outline: 'none'
        }}
      >
        <div style={{fontSize:'14px'}}>
          {fontFamilySelected.current ? 
            <span style={{fontFamily: fontFamilySelected.current}}>{fontFamilySelected.current}</span> : 
            "Select Font"
          }
        </div>
        <div style={{ fontSize: '12px' }}><span>{isOpen ?'▼':'▶'}</span></div>
      </summary>
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
          padding: '8px',
          backgroundColor: '#2d2d2d'
        }}
      >
        {fontFamilies.map((font) => {
          const isSelected = segment.style.fontFamily === font.name;
          return (
            <button
              key={font.name}
              onClick={() => {
                fontFamilySelected.current = font.name;
                handleStyleUpdate('fontFamily', font.name);
                segment.style.fontFamily = font.name;
                updateIsOpen((prev:boolean) => !prev);
              }}
              className={font.className} // optional: applies font preview class from CSS
              style={{
                backgroundColor: '#333',
                border: isSelected ? '2px solid #2196f3' : '1px solid #555',
                color: '#e0e0e0',
                padding: '6px 12px',
                fontSize: '14px',
                borderRadius: '4px',
                cursor: 'pointer',
                transition: 'background-color 0.3s ease, border-color 0.3s ease',
                fontFamily: font.name,
              }}
            >
              {font.name}
            </button>
          );
        })}
      </div>
    </details>
  );
};

// To hide the default details marker in browsers
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  details summary::-webkit-details-marker {
    display: none;
  }
  details summary::marker {
    display: none; 
  }
`;
document.head.appendChild(styleSheet);

export default FontAccordion;